import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';

export const RadioGroupRoot = ChakraRadioGroup.Root;
export const RadioGroupItem = ChakraRadioGroup.Item;
export const RadioGroupItemHiddenInput = ChakraRadioGroup.ItemHiddenInput;
export const RadioGroupItemIndicator = ChakraRadioGroup.ItemIndicator;
export const RadioGroupItemText = ChakraRadioGroup.ItemText;